import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { LocalizationModule } from '../../../localization/localization.module';
import { ListPlugin } from './components/list-plugin/list-plugin.component';
import { ListPluginModal } from './components/list-plugin-modal/list-plugin.modal';
import { ChassisModalModule } from '../../../modals/modals.module';
import { FormsModule } from '../../../forms/forms.module';
import { ChassisAlertModule } from '../../../alerts/alert.module';
import { ListTableColumnComponent } from './components/list-table-column/list-table-column.component';
import { ListItemComponent } from './components/list-item/list-item.component';
import { ListItemTemplate } from './components/list-item-template/list-item-template.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ChassisAlertModule,
        ChassisModalModule,
        LocalizationModule
    ],
    declarations: [
        ListPlugin,
        ListPluginModal,
        ListTableColumnComponent,
        ListItemComponent,
        ListItemTemplate
    ],
    entryComponents: [
        ListPlugin,
        ListPluginModal,
        ListTableColumnComponent,
        ListItemComponent,
        ListItemTemplate
    ],
    providers: [],
    exports: [
        CommonModule,
        FormsModule,
        ChassisAlertModule,
        ChassisModalModule,
        LocalizationModule,
        ListPlugin,
        ListPluginModal,
        ListTableColumnComponent,
        ListItemComponent,
        ListItemTemplate
    ],
})
export class AbstractPluginsModule {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/abstract-plugins.module.ts